import { render, staticRenderFns } from "./cModalSuCategories.vue?vue&type=template&id=3fb6b8c8"
import script from "./cModalSuCategories.vue?vue&type=script&lang=js"
export * from "./cModalSuCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports